import { ActionContext, Module } from "vuex";

import { Modes } from "@/modes";
import { RootState } from "@/store/root";
import { Evidence, Match, Mode } from "@/types";

export interface DetailsState {
  subject?: Mode;
  match?: Match;
  evidence?: Evidence;
}

export const details: Module<DetailsState, RootState> = {
  state: {
    subject: undefined,
    match: undefined,
    evidence: undefined
  },
  namespaced: true,
  mutations: {
    UPDATE_MATCH(state: DetailsState, value: Match) {
      state.subject = Modes.Analysis;
      state.match = value;
      state.evidence = undefined;
    },
    UPDATE_EVIDENCE(state: DetailsState, value: Evidence) {
      state.subject = Modes.Encode;
      state.evidence = value;
      state.match = undefined;
    },
    CLEAR(state: DetailsState) {
      state.subject = undefined;
      state.match = undefined;
      state.evidence = undefined;
    }
  },
  actions: {
    update(
      context: ActionContext<DetailsState, RootState>,
      value: Evidence | Match | null
    ) {
      if (!value) {
        return context.commit("CLEAR");
      }

      if ((value as Match).concept !== undefined) {
        return context.commit("UPDATE_MATCH", value);
      }

      context.commit("evidences/INSPECT", value, { root: true });
      return context.commit("UPDATE_EVIDENCE", value);
    }
  }
};
